"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ClassifierAdminPage = void 0;
const react_1 = __importDefault(require("react"));
const react_router_1 = require("react-router");
const EditEntity_1 = require("./components/EditEntity");
const EditEntityForm_1 = require("./components/EditEntityForm");
const EntityList_1 = require("./components/EntityList");
const NewEntity_1 = require("./components/NewEntity");
function ClassifierAdminPage(props) {
    return (react_1.default.createElement(react_router_1.Routes, null,
        react_1.default.createElement(react_router_1.Route, { path: '', element: react_1.default.createElement(EntityList_1.EntityList, Object.assign({}, props)) }),
        react_1.default.createElement(react_router_1.Route, { path: 'new', element: react_1.default.createElement(NewEntity_1.NewEntity, Object.assign({}, props)) }),
        react_1.default.createElement(react_router_1.Route, { path: ':id', element: react_1.default.createElement(EditEntity_1.EditEntity, Object.assign({}, props)) }),
        react_1.default.createElement(react_router_1.Route, { path: ':id/edit-form', element: react_1.default.createElement(EditEntityForm_1.EditEntityForm, Object.assign({}, props)) })));
}
exports.ClassifierAdminPage = ClassifierAdminPage;
